



























































import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import ApiClient from '@/services/api-client'
import { CvType } from '@/models'

// cv_type.type_id is a char(4) PK: exactly 4 lowercase letters or digits.
const TYPE_ID_REGEX = /^[a-z0-9]{4}$/

function emptyForm(): CvType {
  return { typeId: '', name: '' }
}

@Component
export default class UpsertCvTypeModal extends Vue {
  @Prop({ required: false }) type: CvType | null

  private form: CvType = emptyForm()
  private saving = false

  @Watch('type', { deep: true })
  onTypeChanged() {
    this.form = this.type ? { ...this.type } : emptyForm()
  }

  get isNew(): boolean {
    return this.type == null
  }

  // null = neutral (empty); true/false drive the validation styling.
  get typeIdState(): boolean | null {
    if (!this.form.typeId) return null
    return TYPE_ID_REGEX.test(this.form.typeId)
  }

  private formOk(): boolean {
    if (!this.form.typeId || !this.form.name || !this.form.name.trim()) return false
    return TYPE_ID_REGEX.test(this.form.typeId)
  }

  hideModal() {
    this.$bvModal.hide('UpsertCvTypeModal')
  }

  private saveForm(): void {
    if (!this.formOk() || this.saving) return

    const payload: CvType = {
      typeId: this.form.typeId.trim().toLowerCase(),
      name: this.form.name.trim()
    }

    const promise = this.isNew
      ? ApiClient.createCvType(payload)
      : ApiClient.updateCvType(payload.typeId, payload)

    this.saving = true
    promise
      .then((saved: CvType) => {
        this.$emit('saved', saved)
        this.hideModal()
        this.form = emptyForm()
      })
      .catch((ex: Error) => {
        this.$bvToast.toast(ex.message, {
          title: this.$t('feedback.error_title_generic').toString(),
          variant: 'danger',
          solid: true
        })
      })
      .finally(() => {
        this.saving = false
      })
  }
}
